import IndividualEvalTab from './IndividualEvalTab';
import ReviewAnalysisTab from './ReviewAnalysisTab';
import UnitManagerTab from './UnitManagerTab';
import React, { useState, useEffect } from 'react';
import api from '../api/client';

const S = {
  wrap: { maxWidth: 960, margin: '0 auto', fontFamily: 'inherit' },
  header: { background: '#2d4a8a', color: '#fff', padding: '12px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
  body: { background: '#f0f2f5', minHeight: '100vh', padding: 16 },
  nav: { display: 'flex', gap: 8, marginBottom: 20, flexWrap: 'wrap' },
  navBtn: { padding: '8px 16px', border: '1px solid #d0d8e8', borderRadius: 8, background: '#fff', color: '#666', fontSize: 13, cursor: 'pointer' },
  navBtnActive: { padding: '8px 16px', border: '1px solid #2d4a8a', borderRadius: 8, background: '#2d4a8a', color: '#fff', fontSize: 13, cursor: 'pointer' },
  card: { background: '#fff', border: '1px solid #d0d8e8', borderRadius: 12, padding: 20, marginBottom: 16 },
  cardTitle: { fontSize: 14, fontWeight: 600, color: '#333', marginBottom: 14 },
  grid3: { display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 12, marginBottom: 16 },
  metric: { background: '#f5f7fb', borderRadius: 8, padding: 14 },
  metricLabel: { fontSize: 12, color: '#888', marginBottom: 4 },
  metricVal: { fontSize: 22, fontWeight: 600, color: '#333' },
  row: { display: 'flex', alignItems: 'center', gap: 10, padding: '9px 0', borderBottom: '1px solid #f0f2f5', fontSize: 13 },
  badgeDone: { padding: '3px 10px', borderRadius: 99, fontSize: 11, background: '#e1f5ee', color: '#085041', whiteSpace: 'nowrap' },
  badgeWait: { padding: '3px 10px', borderRadius: 99, fontSize: 11, background: '#faeeda', color: '#633806', whiteSpace: 'nowrap' },
  subjectTag: { padding: '3px 10px', background: '#e6f1fb', color: '#0c447c', borderRadius: 6, fontSize: 11, whiteSpace: 'nowrap' },
  gradeTag: { padding: '3px 10px', background: '#eeedfe', color: '#3c3489', borderRadius: 6, fontSize: 11, whiteSpace: 'nowrap' },
  studentTag: { padding: '4px 12px', background: '#2d4a8a', color: '#fff', borderRadius: 6, fontSize: 12, fontWeight: 600, whiteSpace: 'nowrap' },
  btn: { padding: '7px 14px', border: '1px solid #d0d8e8', borderRadius: 8, background: '#fff', color: '#666', fontSize: 12, cursor: 'pointer' },
  btnPrimary: { padding: '8px 16px', border: 'none', borderRadius: 8, background: '#2d4a8a', color: '#fff', fontSize: 13, cursor: 'pointer' },
  btnDanger: { padding: '7px 14px', border: '1px solid #e24b4a', borderRadius: 8, background: '#fff', color: '#e24b4a', fontSize: 12, cursor: 'pointer' },
  btnSm: { padding: '4px 10px', border: '1px solid #d0d8e8', borderRadius: 6, background: '#fff', color: '#666', fontSize: 11, cursor: 'pointer' },
  btnEval: { padding: '8px 16px', border: 'none', borderRadius: 8, background: '#534ab7', color: '#fff', fontSize: 13, cursor: 'pointer' },
  label: { fontSize: 13, color: '#666', marginBottom: 6, display: 'block' },
  input: { width: '100%', padding: '9px 12px', border: '1px solid #d0d8e8', borderRadius: 8, fontSize: 14, marginBottom: 12, outline: 'none', boxSizing: 'border-box' },
  inputSm: { padding: '6px 10px', border: '1px solid #d0d8e8', borderRadius: 6, fontSize: 13, outline: 'none', width: 140 },
  select: { padding: '7px 10px', border: '1px solid #d0d8e8', borderRadius: 8, fontSize: 13, background: '#fff' },
  selectSm: { padding: '5px 8px', border: '1px solid #d0d8e8', borderRadius: 6, fontSize: 12, background: '#fff' },
  selectFull: { width: '100%', padding: '9px 12px', border: '1px solid #d0d8e8', borderRadius: 8, fontSize: 14, marginBottom: 12, background: '#fff' },
  logoutBtn: { fontSize: 12, padding: '5px 12px', border: '1px solid rgba(255,255,255,0.5)', borderRadius: 6, cursor: 'pointer', background: 'transparent', color: '#fff' },
  reviewCard: { border: '1px solid #d0d8e8', borderRadius: 10, padding: 14, marginBottom: 14 },
  reviewHeader: { display: 'flex', gap: 8, alignItems: 'center', marginBottom: 10, flexWrap: 'wrap' },
  reviewBubble: { background: '#f5f7fb', borderRadius: 8, padding: '10px 14px', fontSize: 14, marginBottom: 8, lineHeight: 1.6 },
  aiBubble: { background: '#e6f1fb', borderRadius: 8, padding: '10px 14px', fontSize: 13, color: '#0c447c', lineHeight: 1.6 },
  settingRow: { display: 'flex', alignItems: 'center', gap: 10, padding: '12px 0', borderBottom: '1px solid #f0f2f5' },
  textarea: { width: '100%', minHeight: 80, padding: '9px 12px', border: '1px solid #d0d8e8', borderRadius: 8, fontSize: 13, marginBottom: 12, resize: 'vertical', boxSizing: 'border-box' },
  successMsg: { background: '#e1f5ee', color: '#085041', borderRadius: 8, padding: '10px 14px', fontSize: 13, marginBottom: 12 },
  errorMsg: { background: '#fff5f5', color: '#e24b4a', borderRadius: 8, padding: '10px 14px', fontSize: 13, marginBottom: 12 },
  classTab: { display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 16 },
  classTabBtn: { padding: '6px 14px', border: '1px solid #d0d8e8', borderRadius: 99, background: '#fff', color: '#666', fontSize: 12, cursor: 'pointer' },
  classTabBtnActive: { padding: '6px 14px', border: '1px solid #2d4a8a', borderRadius: 99, background: '#2d4a8a', color: '#fff', fontSize: 12, cursor: 'pointer' },
  pwEditRow: { display: 'flex', alignItems: 'center', gap: 8 },
  evalBox: { background: '#f0eefe', border: '1px solid #afa9ec', borderRadius: 10, padding: 16, marginTop: 16, lineHeight: 1.8, fontSize: 14, color: '#26215c' },
  unitGroup: { marginBottom: 20 },
  unitGroupHeader: { fontSize: 13, fontWeight: 600, color: '#2d4a8a', background: '#e6f1fb', padding: '6px 12px', borderRadius: 6, marginBottom: 8 },
};

function formatDateTime(d) {
  const dt = new Date(d);
  return `${dt.getMonth()+1}/${dt.getDate()} ${String(dt.getHours()).padStart(2,'0')}:${String(dt.getMinutes()).padStart(2,'0')}`;
}

const GRADES_BY_TYPE = {
  elementary: [1,2,3,4,5,6],
  junior:     [1,2,3],
  special:    [1,2,3,4,5,6],
};

export default function TeacherPage() {
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
  const schoolType = userInfo.school_type || 'elementary';
  const GRADES = GRADES_BY_TYPE[schoolType] || GRADES_BY_TYPE.elementary;
  const [section, setSection] = useState('dashboard');
  const [dashboard, setDashboard] = useState({ today: 0, week: 0, no_comment: 0 });
  const [reviews, setReviews] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [classes, setClasses] = useState([]);
  const [students, setStudents] = useState([]);
  const [selectedClass, setSelectedClass] = useState(null);
  const [settings, setSettings] = useState(null);
  const [filterSubject, setFilterSubject] = useState('');
  const [filterSubjectName, setFilterSubjectName] = useState('');
  const [filterGrade, setFilterGrade] = useState('');
  const [newSubject, setNewSubject] = useState({ grade: '', subject_name: '', unit_name: '', unit_target: '' });
  const [editSubject, setEditSubject] = useState(null);
  const [expandedSubjects, setExpandedSubjects] = useState({});
  const toggleSubjectExpand = (key) => setExpandedSubjects(prev => ({ ...prev, [key]: !prev[key] }));
  const [editingPw, setEditingPw] = useState({});
  const [newPw, setNewPw] = useState({});
  const [successMsg, setSuccessMsg] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [loading, setLoading] = useState(false);
  const [evalSubjectId, setEvalSubjectId] = useState('');
  const [evalResult, setEvalResult] = useState(null);
  const [evalLoading, setEvalLoading] = useState(false);

  useEffect(() => { fetchDashboard(); fetchReviews(); fetchSubjects(); fetchClasses(); fetchSettings(); }, []);

  const fetchDashboard = async () => { try { const r = await api.get('/dashboard'); setDashboard(r.data); } catch(e) {} };
  const fetchReviews = async () => { setLoading(true); try { const r = await api.get('/reviews'); setReviews(r.data); } catch(e) {} finally { setLoading(false); } };
  const fetchSubjects = async () => { try { const r = await api.get('/subjects'); setSubjects(r.data); } catch(e) {} };
  const fetchClasses = async () => { try { const r = await api.get('/classes'); setClasses(r.data); } catch(e) {} };
  const fetchSettings = async () => { try { const r = await api.get('/settings'); setSettings(r.data); } catch(e) {} };
  const fetchStudents = async (id) => { try { const r = await api.get(`/classes/${id}/students`); setStudents(r.data); } catch(e) {} };

  const showSuccess = (msg) => { setSuccessMsg(msg); setTimeout(() => setSuccessMsg(''), 3000); };
  const showError   = (msg) => { setErrorMsg(msg);   setTimeout(() => setErrorMsg(''), 3000); };

  const addSubject = async () => {
    if (!newSubject.grade) { showError('学年を選択してください'); return; }
    if (!newSubject.subject_name) { showError('教科名を入力してください'); return; }
    try {
      await api.post('/subjects', {
        subject_name: newSubject.subject_name,
        unit_name: newSubject.unit_name,
        unit_target: newSubject.unit_target,
        grade: newSubject.grade ? parseInt(newSubject.grade) : null
      });
      setNewSubject({ grade: '', subject_name: '', unit_name: '', unit_target: '' });
      fetchSubjects(); showSuccess('追加しました');
    } catch(e) { showError('追加に失敗しました'); }
  };

  const updateSubject = async (id, data) => {
    try { await api.put(`/subjects/${id}`, data); fetchSubjects(); setEditSubject(null); showSuccess('更新しました'); }
    catch(e) { showError('更新に失敗しました'); }
  };

  const deactivateSubject = async (id) => {
    if (!window.confirm('この単元目標を無効化しますか？')) return;
    try { await api.delete(`/subjects/${id}`); fetchSubjects(); showSuccess('無効化しました'); }
    catch(e) { showError('無効化に失敗しました'); }
  };

  const updatePassword = async (studentId) => {
    const pw = newPw[studentId];
    if (!pw || pw.length < 4) { showError('4文字以上のパスワードを入力してください'); return; }
    try {
      await api.patch(`/students/${studentId}/password`, { password: pw });
      setEditingPw(prev => ({ ...prev, [studentId]: false }));
      setNewPw(prev => ({ ...prev, [studentId]: '' }));
      showSuccess('パスワードを変更しました');
    } catch(e) { showError('変更に失敗しました'); }
  };

  const saveSettings = async () => {
    try { await api.put('/settings', settings); showSuccess('設定を保存しました'); }
    catch(e) { showError('保存に失敗しました'); }
  };

  const runEvaluation = async () => {
    if (!evalSubjectId) { showError('教科・単元を選択してください'); return; }
    setEvalLoading(true); setEvalResult(null);
    try {
      const params = { subject_id: evalSubjectId };
      if (filterGrade) params.grade = filterGrade;
      const r = await api.get('/evaluate/class', { params });
      setEvalResult(r.data);
    } catch(e) { showError(e.response?.data?.error || 'AI評価に失敗しました'); }
    finally { setEvalLoading(false); }
  };

  const downloadCSV = (url, filename) => {
    const token = localStorage.getItem('token');
    fetch(url, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.blob())
      .then(blob => {
        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = filename;
        a.click();
      }).catch(() => showError('ダウンロードに失敗しました'));
  };

  const filteredReviews = reviews.filter(r => {
    if (filterSubjectName) {
      const s = subjects.find(s => s.id === r.subject_id);
      if (!s || s.subject_name !== filterSubjectName) return false;
    }
    if (filterSubject && String(r.subject_id) !== filterSubject) return false;
    if (filterGrade && String(r.grade) !== filterGrade) return false;
    return true;
  });

  const groupedSubjects = subjects.reduce((acc, s) => {
    const gradeKey = s.grade ? `${s.grade}年生` : '学年未設定';
    if (!acc[gradeKey]) acc[gradeKey] = {};
    const subjectKey = s.subject_name;
    if (!acc[gradeKey][subjectKey]) acc[gradeKey][subjectKey] = [];
    acc[gradeKey][subjectKey].push(s);
    return acc;
  }, {});

  // 体験版でもログアウトしたらログイン画面へ（以前は /demo に戻り、体験版から出られなかった）
  const logout = () => { localStorage.clear(); window.location.href = '/login'; };
  const [showManual, setShowManual] = useState(false);

  return (
    <div style={S.wrap}>
      <div style={S.header}>
        <div style={{ fontSize: 15, fontWeight: 600 }}>ふりカエル 教師管理画面</div>
        <div style={{ fontSize: 12, opacity: 0.8 }}>{userInfo.school_name}</div>
        <button style={{ ...S.logoutBtn, marginRight: 8 }} onClick={() => setShowManual(true)}>📖 操作マニュアル</button>
        <button style={S.logoutBtn} onClick={logout}>ログアウト</button>
      </div>
      {userInfo.school_code === 'DEMO01' && (
        <div style={{ background: '#fef08a', borderBottom: '2px solid #ca8a04', padding: '10px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 8 }}>
          <div style={{ fontSize: 13, color: '#713f12', fontWeight: 'bold' }}>
            🎮 これは体験版です。実際のデータには影響しません。
          </div>
          <button
            onClick={() => {
              const demoInfo = { role: 'student', school_name: 'ふりカエル体験校', school_code: 'DEMO01', grade: 4, class_name: '1', number: 1 };
              fetch('/api/auth/student/login', { method: 'POST', headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ school_code: 'DEMO01', grade: 4, class_name: '1', number: 1, password: 'password' }) })
                .then(r => r.json()).then(data => {
                  localStorage.setItem('token', data.token);
                  localStorage.setItem('role', 'student');
                  localStorage.setItem('userInfo', JSON.stringify({ ...data, ...demoInfo }));
                  window.location.href = '/student';
                });
            }}
            style={{ fontSize: 12, color: '#713f12', background: 'rgba(0,0,0,0.1)', border: '1px solid #ca8a04', padding: '6px 14px', borderRadius: 6, cursor: 'pointer', fontWeight: 'bold' }}>
            🧒 児童画面を体験する
          </button>
        </div>
      )}
      <div style={S.body}>
        <div style={S.nav}>
          {[['dashboard','ダッシュボード'],['reviews','ふりかえり一覧'],['evaluate','ふりかえり分析'],['subjects','単元（目標）設定・AI評価管理'],['students','児童管理'],['settings','学校設定']].map(([k,v]) => (
            <button key={k} style={section===k ? S.navBtnActive : S.navBtn} onClick={() => setSection(k)}>{v}</button>
          ))}
        </div>

        {successMsg && <div style={S.successMsg}>{successMsg}</div>}
        {errorMsg   && <div style={S.errorMsg}>{errorMsg}</div>}

        {section === 'dashboard' && (
          <>
            <div style={S.grid3}>
              <div style={S.metric}><div style={S.metricLabel}>本日の提出数</div><div style={S.metricVal}>{dashboard.today}</div></div>
              <div style={S.metric}><div style={S.metricLabel}>今週の合計</div><div style={S.metricVal}>{dashboard.week}</div></div>
              <div style={S.metric}><div style={S.metricLabel}>未コメント</div><div style={{ ...S.metricVal, color: dashboard.no_comment > 0 ? '#ba7517' : '#333' }}>{dashboard.no_comment}</div></div>
            </div>
            <div style={S.card}>
              <div style={S.cardTitle}>最新のふりかえり</div>
              {reviews.slice(0, 5).map(r => (
                <div key={r.id} style={S.row}>
                  <span style={S.studentTag}>{r.grade}年{r.class_name} {r.number}番</span>
                  <span style={S.subjectTag}>{r.subject_name}</span>
                  <span style={{ flex: 1, color: '#555' }}>{r.content?.slice(0, 22)}…</span>
                  <span style={r.ai_comment ? S.badgeDone : S.badgeWait}>{r.ai_comment ? 'コメント済' : '確認待ち'}</span>
                </div>
              ))}
            </div>
          </>
        )}

        {section === 'reviews' && (
          <div style={S.card}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14, flexWrap: 'wrap' }}>
              <div style={S.cardTitle}>ふりかえり一覧</div>
              <select style={S.select} value={filterGrade} onChange={e => setFilterGrade(e.target.value)}>
                <option value="">すべての学年</option>
                {GRADES.map(g => <option key={g} value={g}>{g}年生</option>)}
              </select>
              <select style={S.select} value={filterSubjectName} onChange={e => { setFilterSubjectName(e.target.value); setFilterSubject(''); }}>
                <option value="">すべての教科</option>
                {[...new Set(subjects.filter(s => !filterGrade || !s.grade || String(s.grade) === filterGrade).map(s => s.subject_name))].map(name => <option key={name} value={name}>{name}</option>)}
              </select>
              {filterSubjectName && (() => {
                const units = subjects.filter(s => s.subject_name === filterSubjectName && (!filterGrade || !s.grade || String(s.grade) === filterGrade) && s.unit_name);
                if (units.length === 0) {
                  const s = subjects.find(s => s.subject_name === filterSubjectName);
                  return null;
                }
                return (
                  <select style={S.select} value={filterSubject} onChange={e => setFilterSubject(e.target.value)}>
                    <option value="">すべての単元</option>
                    {units.map(s => <option key={s.id} value={s.id}>{s.unit_name}</option>)}
                  </select>
                );
              })()}
              <button style={S.btn} onClick={fetchReviews}>更新</button>
              <button style={{ ...S.btn, color: '#2d4a8a', borderColor: '#2d4a8a' }}
                onClick={() => {
                  const params = new URLSearchParams();
                  if (filterSubject) params.append('subject_id', filterSubject);
                  if (filterGrade) params.append('grade', filterGrade);
                  downloadCSV(`/api/export/reviews?${params.toString()}`, 'furikaeru_export.csv');
                }}>
                CSVで保存
              </button>
            </div>
            {loading && <div style={{ color: '#aaa', fontSize: 13 }}>読み込み中...</div>}
            {filteredReviews.map(r => (
              <div key={r.id} style={S.reviewCard}>
                <div style={S.reviewHeader}>
                  <span style={S.studentTag}>{r.grade}年{r.class_name} {r.number}番</span>
                  <span style={S.subjectTag}>{r.subject_name}{r.unit_name ? ` / ${r.unit_name}` : ''}</span>
                  <span style={{ fontSize: 12, color: '#aaa' }}>{formatDateTime(r.created_at)}</span>
                  <span style={r.ai_comment ? S.badgeDone : S.badgeWait}>{r.ai_comment ? 'コメント済' : '確認待ち'}</span>
                </div>
                {r.unit_target && <div style={{ fontSize: 12, color: '#888', marginBottom: 8 }}>目標：{r.unit_target}</div>}
                <div style={S.reviewBubble}>{r.content}</div>
                {r.emotion_tags?.length > 0 && (
                  <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 8 }}>
                    {r.emotion_tags.map(t => <span key={t} style={{ padding: '2px 8px', borderRadius: 99, border: '1px solid #d0d8e8', fontSize: 11, color: '#888' }}>{t}</span>)}
                  </div>
                )}
                {r.ai_comment && <div style={S.aiBubble}>AIコメント：{r.ai_comment}</div>}
              </div>
            ))}
          </div>
        )}

        {section === 'evaluate' && (
          <ReviewAnalysisTab schoolType={schoolType} />
        )}

        {section === 'subjects' && (<UnitManagerTab schoolType={schoolType} />)}
        {false && (
          <div style={S.card}>
            <div style={S.cardTitle}>教科・単元目標の管理</div>
            <div style={{ marginBottom: 20, paddingBottom: 16, borderBottom: '2px solid #eeedfe' }}>
              <div style={S.cardTitle}>新しい単元目標を追加</div>
              <div style={{ display: 'grid', gridTemplateColumns: '80px 1fr 1fr', gap: 8, marginBottom: 8 }}>
                <div>
                  <label style={{ ...S.label, fontSize: 11 }}>学年</label>
                  <select style={S.selectFull} value={newSubject.grade} onChange={e => setNewSubject({ ...newSubject, grade: e.target.value })}>
                    <option value="">学年を選択 *</option>
                    {GRADES.map(g => <option key={g} value={g}>{g}年</option>)}
                  </select>
                </div>
                <div>
                  <label style={{ ...S.label, fontSize: 11 }}>教科名</label>
                  <input style={S.input} placeholder="例：算数" value={newSubject.subject_name} onChange={e => setNewSubject({ ...newSubject, subject_name: e.target.value })} />
                </div>
                <div>
                  <label style={{ ...S.label, fontSize: 11 }}>単元名</label>
                  <input style={S.input} placeholder="例：かけ算のひっ算" value={newSubject.unit_name} onChange={e => setNewSubject({ ...newSubject, unit_name: e.target.value })} />
                </div>
              </div>
              <label style={{ ...S.label, fontSize: 11 }}>単元目標</label>
              <textarea style={S.textarea} placeholder="例：かけ算のひっ算の仕方を理解し、正確に計算することができる" value={newSubject.unit_target} onChange={e => setNewSubject({ ...newSubject, unit_target: e.target.value })} />
              <button style={S.btnPrimary} onClick={addSubject}>追加する</button>
            </div>
            {Object.entries(groupedSubjects).sort().map(([gradeLabel, subjectGroups]) => (
              <div key={gradeLabel} style={S.unitGroup}>
                <div style={S.unitGroupHeader}>{gradeLabel}</div>
                {Object.entries(subjectGroups).sort().map(([subjectName, subs]) => (
                  <div key={subjectName} style={{ borderBottom: '1px solid #f0f2f5' }}>
                    <div onClick={() => toggleSubjectExpand(`${gradeLabel}-${subjectName}`)}
                      style={{ display: 'flex', alignItems: 'center', padding: '10px 12px', cursor: 'pointer', background: expandedSubjects[`${gradeLabel}-${subjectName}`] ? '#f5f7fb' : 'white', userSelect: 'none' }}>
                      <span style={{ ...S.subjectTag, marginRight: 8 }}>{subjectName}</span>
                      <span style={{ flex: 1, fontSize: 12, color: '#aaa' }}>{subs.length}単元</span>
                      <span style={{ fontSize: 12, color: '#999' }}>{expandedSubjects[`${gradeLabel}-${subjectName}`] ? '▲' : '▼'}</span>
                    </div>
                    {expandedSubjects[`${gradeLabel}-${subjectName}`] && subs.map(s => (
                  <div key={s.id} style={{ paddingLeft: 12 }}>
                    {editSubject?.id === s.id ? (
                      <div style={{ padding: '10px 0 10px 12px', borderBottom: '1px solid #f0f2f5' }}>
                        <div style={{ display: 'grid', gridTemplateColumns: '80px 1fr 1fr', gap: 8, marginBottom: 8 }}>
                          <div>
                            <div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>学年</div>
                            <select style={S.selectFull} value={editSubject.grade || ''} onChange={e => setEditSubject({ ...editSubject, grade: e.target.value })}>
                              <option value="">未設定</option>
                              {GRADES.map(g => <option key={g} value={g}>{g}年</option>)}
                            </select>
                          </div>
                          <div>
                            <div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>教科</div>
                            <input style={S.input} value={editSubject.subject_name} onChange={e => setEditSubject({ ...editSubject, subject_name: e.target.value })} />
                          </div>
                          <div>
                            <div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>単元名</div>
                            <input style={S.input} placeholder="例：かけ算のひっ算" value={editSubject.unit_name || ''} onChange={e => setEditSubject({ ...editSubject, unit_name: e.target.value })} />
                          </div>
                        </div>
                        <div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>単元目標</div>
                        <textarea style={S.textarea} value={editSubject.unit_target || ''} onChange={e => setEditSubject({ ...editSubject, unit_target: e.target.value })} />
                        <div style={{ display: 'flex', gap: 8 }}>
                          <button style={S.btnPrimary} onClick={() => updateSubject(s.id, { subject_name: editSubject.subject_name, unit_name: editSubject.unit_name, unit_target: editSubject.unit_target, grade: editSubject.grade ? parseInt(editSubject.grade) : null })}>保存</button>
                          <button style={S.btn} onClick={() => setEditSubject(null)}>キャンセル</button>
                        </div>
                      </div>
                    ) : (
                      <div style={S.row}>
                        <span style={S.subjectTag}>{s.subject_name}</span>
                        <div style={{ flex: 1 }}>
                          {s.unit_name && <div style={{ fontSize: 12, fontWeight: 600, color: '#333', marginBottom: 2 }}>{s.unit_name}</div>}
                          <div style={{ fontSize: 12, color: s.unit_target ? '#666' : '#aaa' }}>{s.unit_target || '目標未設定'}</div>
                        </div>
                        <button style={S.btn} onClick={() => setEditSubject({ ...s })}>編集</button>
                        <button style={S.btnDanger} onClick={() => deactivateSubject(s.id)}>削除</button>
                      </div>
                    )}
                  </div>
                    ))}
                  </div>
                ))}
              </div>
            ))}
          </div>
        )}

        {section === 'students' && (
          <>
            <div style={S.card}>
              <div style={S.cardTitle}>クラス選択</div>
              <div style={S.classTab}>
                {classes.map(c => (
                  <button key={c.id} style={selectedClass?.id === c.id ? S.classTabBtnActive : S.classTabBtn} onClick={() => { setSelectedClass(c); fetchStudents(c.id); }}>
                    {c.grade}年{c.class_name}
                  </button>
                ))}
              </div>
              {!selectedClass && <div style={{ color: '#aaa', fontSize: 13 }}>クラスを選択してください</div>}
            </div>
            {selectedClass && (
              <div style={S.card}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }}>
                  <div style={S.cardTitle}>{selectedClass.grade}年{selectedClass.class_name}　（{students.length}名）</div>
                </div>
                {students.map(s => (
                  <div key={s.id} style={S.row}>
                    <span style={S.studentTag}>{s.number}番</span>
                    <span style={{ flex: 1, fontSize: 12, color: '#888' }}>ふりかえり：{s.review_count}回</span>
                    {editingPw[s.id] ? (
                      <div style={S.pwEditRow}>
                        <input style={S.inputSm} type="text" placeholder="新しいパスワード" value={newPw[s.id] || ''} onChange={e => setNewPw(prev => ({ ...prev, [s.id]: e.target.value }))} />
                        <button style={S.btnPrimary} onClick={() => updatePassword(s.id)}>保存</button>
                        <button style={S.btn} onClick={() => setEditingPw(prev => ({ ...prev, [s.id]: false }))}>取消</button>
                      </div>
                    ) : (
                      <button style={S.btnSm} onClick={() => setEditingPw(prev => ({ ...prev, [s.id]: true }))}>PW変更</button>
                    )}
                  </div>
                ))}
              </div>
            )}
          </>
        )}

        {section === 'settings' && settings && (
          <div style={S.card}>
            <div style={S.cardTitle}>学校設定</div>
            <div style={S.settingRow}>
              <span style={{ flex: 1, fontSize: 13 }}>AIコメントの表示</span>
              <select style={S.select} value={settings.ai_comment_mode || 'instant'} onChange={e => setSettings({ ...settings, ai_comment_mode: e.target.value })}>
                <option value="instant">送信後すぐに表示</option>
                <option value="teacher_review">教師確認後に表示</option>
              </select>
            </div>
            <div style={S.settingRow}>
              <span style={{ flex: 1, fontSize: 13 }}>感情タグ</span>
              <select style={S.select} value={settings.use_emotion_tags ? 'on' : 'off'} onChange={e => setSettings({ ...settings, use_emotion_tags: e.target.value === 'on' })}>
                <option value="on">使用する</option>
                <option value="off">使用しない</option>
              </select>
            </div>
            <div style={S.settingRow}>
              <span style={{ flex: 1, fontSize: 13 }}>ふり返りのヒント</span>
              <select style={S.select} value={settings.use_hints ? 'on' : 'off'} onChange={e => setSettings({ ...settings, use_hints: e.target.value === 'on' })}>
                <option value="on">表示する</option>
                <option value="off">表示しない</option>
              </select>
            </div>
            <div style={S.settingRow}>
              <span style={{ flex: 1, fontSize: 13 }}>最大文字数</span>
              <select style={S.select} value={settings.max_review_length || 400} onChange={e => setSettings({ ...settings, max_review_length: parseInt(e.target.value) })}>
                <option value={200}>200文字</option>
                <option value={400}>400文字</option>
                <option value={0}>制限なし</option>
              </select>
            </div>
            <div style={{ marginTop: 16 }}>
              <button style={S.btnPrimary} onClick={saveSettings}>保存する</button>
            </div>
          </div>
        )}
      </div>
      {showManual && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', overflowY: 'auto', padding: '20px' }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: '32px', maxWidth: 800, width: '100%', position: 'relative', marginTop: 20, marginBottom: 20 }}>
            <button onClick={() => setShowManual(false)} style={{ position: 'absolute', top: 16, right: 16, background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: '#666' }}>✕</button>
            <h2 style={{ fontSize: 22, fontWeight: 'bold', color: '#2d4a8a', marginBottom: 8 }}>📖 ふりカエル 操作マニュアル</h2>
            <p style={{ fontSize: 13, color: '#888', marginBottom: 24 }}>教師向けの操作手順をご確認いただけます。</p>

            {[
              { title: '1. 最初にやること（重要）', color: '#fff3e8', border: '#f97316', content: [
                '⚠️ 児童・生徒がふりかえりを入力するには、教師が先に「単元目標」を設定する必要があります。',
                '単元目標が未設定の場合、児童の入力画面に教科が表示されません。',
              ]},
              { title: '2. 単元目標の設定手順', color: '#f0f4ff', border: '#2d4a8a', content: [
                'STEP1：「教科・目標設定」タブを開く',
                'STEP2：学年・教科名・単元名・単元目標を入力する',
                'STEP3：「追加する」ボタンをクリック',
                '💡 教科名をクリックすると単元一覧が折りたたみ表示されます',
              ]},
              { title: '3. ふりかえり一覧の確認', color: '#f0f4ff', border: '#2d4a8a', content: [
                '「ふりかえり一覧」タブで児童・生徒のふりかえりを確認できます',
                '学年→教科→単元の順で絞り込みができます',
                '「CSVで保存」でExcel用ファイルをダウンロードできます',
              ]},
              { title: '4. AI評価の活用', color: '#f0f4ff', border: '#2d4a8a', content: [
                '「AI評価」タブで単元ごとの個人別AI評価を生成できます',
                '学年→教科→単元を選んで「AI評価を実行」をクリック',
                '5段階評価・評価コメント・根拠が表示されます（1〜2分かかります）',
                '評価結果はCSVで保存して通知表作成などに活用できます',
              ]},
              { title: '5. 評価の見方', color: '#f0f4ff', border: '#2d4a8a', content: [
                '5（卓越）：振り返り多数・内容充実・深い理解・顕著な成長',
                '4（優秀）：継続的な振り返り・高品質な記述・理解が深まっている',
                '3（標準）：適切な回数・標準的な記述・基本的な理解',
                '2（努力中）：記録少なめ・簡潔な記述・理解の定着が途上',
                '1（要支援）：記録がほとんどない・または内容が非常に乏しい',
              ]},
              { title: '6. よくある質問', color: '#f0f4ff', border: '#2d4a8a', content: [
                'Q. 児童の教科選択に教科が表示されない → 「教科・目標設定」で単元目標を登録してください',
                'Q. AI評価に時間がかかる → 人数が多いほど時間がかかります（最大2〜3分）',
                'Q. パスワードを忘れた → 管理者にご連絡ください',
                'Q. データをExcelで管理したい → 各画面の「CSVで保存」をご利用ください',
              ]},
            ].map((sec, i) => (
              <div key={i} style={{ marginBottom: 20, border: `2px solid ${sec.border}`, borderRadius: 8, overflow: 'hidden' }}>
                <div style={{ background: sec.border, color: '#fff', padding: '8px 16px', fontWeight: 'bold', fontSize: 14 }}>{sec.title}</div>
                <div style={{ background: sec.color, padding: '12px 16px' }}>
                  {sec.content.map((line, j) => (
                    <p key={j} style={{ fontSize: 13, margin: '4px 0', color: '#333' }}>{line}</p>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
